import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Privacy() {
  return (
    <div className="bg-cream min-h-screen">
      <Nav />
      <section className="max-w-3xl mx-auto px-6 sm:px-10 pt-20 pb-24">
        <div className="text-[11px] uppercase tracking-[0.35em] text-teal mb-6">— Privacy Policy</div>
        <h1 className="font-display text-5xl sm:text-6xl text-navy leading-[0.95] mb-10">
          How we handle your <em className="text-gold not-italic">information.</em>
        </h1>
        <div className="prose-navy space-y-6 text-navy/80 leading-relaxed text-[15px]">
          <p className="text-[10px] uppercase tracking-[0.28em] text-navy/50">Effective: February 2026</p>
          <p>
            LocalRida is a lead-generation service that connects arriving travelers with independent, licensed
            private transfer operators. This page explains, in plain language, what we collect, why, and how long
            we keep it.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">What we collect</h2>
          <p>When you call our tracking line or send us a WhatsApp message, we capture:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>Your phone number (used to route the call and let the operator confirm your ride).</li>
            <li>The pickup time, pickup location, and drop-off location you provide.</li>
            <li>A recording of the call itself.</li>
            <li>Any WhatsApp message body you send us.</li>
            <li>Basic call metadata: duration, whether it was answered, and which operator took it.</li>
          </ul>

          <h2 className="font-display text-3xl text-navy pt-6">How we use it</h2>
          <p>
            Your information is used only to fulfill your transfer request — i.e. to route your call to a
            licensed operator and to help resolve any service issues that may arise. Recordings are additionally
            used to maintain the standard of service and to verify operator conduct. We do not sell, rent, or
            share your data with any party other than the licensed operator connecting your ride.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">Recording disclosure</h2>
          <p>
            Every inbound call plays a brief notice at the start stating that the call may be recorded. By
            remaining on the line after that notice, you consent to the recording.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">How long we keep it</h2>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>
              <strong>Call and WhatsApp recordings</strong> are automatically deleted <strong>90 days</strong>
              after they are created. This window is enforced by a scheduled purge job on our backend and, where
              applicable, by deleting the corresponding recording from our telephony provider.
            </li>
            <li>
              <strong>Lead metadata</strong> (pickup details, timestamps, operator, disposition — but not the
              recording) is retained indefinitely, so we can prove long-term demand to our operator partners in
              aggregate.
            </li>
          </ul>

          <h2 className="font-display text-3xl text-navy pt-6">Access, correction, deletion</h2>
          <p>
            To request access to, correction of, or deletion of your personal data, email
            {" "}<a className="underline hover:text-gold" href="mailto:privacy@localrida.com">privacy@localrida.com</a>{" "}
            from the phone number or WhatsApp handle you contacted us on.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">Contact</h2>
          <p>
            Privacy questions: <a className="underline hover:text-gold" href="mailto:privacy@localrida.com">privacy@localrida.com</a>.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
